export const customary = 'customary';
export const metric = 'metric';

export const defaultUnit = metric;
